import styled from 'styled-components';

import { Grid, Menu } from '@material-ui/core';

export const IconContainer = styled(Grid)`
  align-self: flex-start;
`;

export const StyledMenu = styled(Menu)`
  &&& {
    ul {
      padding: 0px;
    }
    li {
      padding: 0 14px;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: #32c284;
    }
  }
`;
export const Container = styled(Grid)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 15%, #000000 116%);
  height: 78px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  position: absolute !important;
`;
